type CalculateGridSnapParams = {
  spanDirection: "left" | "right";
  relativeX: number;
  gridSize: number;
  xScrollOffset: number;
  containerWidth: number;
};

export const calculateGridSnapInCard = ({
  containerWidth,
  gridSize,
  relativeX,
  spanDirection,
  xScrollOffset,
}: CalculateGridSnapParams): number => {
  const triggerZone = gridSize / 2;
  const xPosition = -relativeX > containerWidth ? containerWidth : relativeX;

  const isFinalZone =
    spanDirection === "right"
      ? relativeX - triggerZone < -(containerWidth - gridSize)
      : relativeX + triggerZone > containerWidth - gridSize;

  const triggeringZone =
    spanDirection === "right" ? -(xPosition % gridSize) : xPosition % gridSize;

  if (triggeringZone > triggerZone || isFinalZone) {
    const gridSnap =
      spanDirection === "right"
        ? Math.floor(relativeX / gridSize) * gridSize
        : Math.ceil(relativeX / gridSize) * gridSize;

    return isFinalZone
      ? (spanDirection === "right"
          ? -(containerWidth - gridSize)
          : containerWidth - gridSize) + xScrollOffset
      : gridSnap + xScrollOffset;
  } else {
    const gridSnap =
      spanDirection === "right"
        ? Math.ceil(relativeX / gridSize) * gridSize
        : Math.floor(relativeX / gridSize) * gridSize;

    return gridSnap + xScrollOffset;
  }
};
